// import './App.css';
import React, { useState, useEffect, createRef } from "react";

import {
  HStack,
  VStack,
  Link,
  Button,
  List,
  ListItem,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
    Table,
    TableCaption,
    Thead,
    Tr,
    Th,
    Tbody,
    Td,
    Tfoot,
    // useDisclosure,
    Checkbox,
  Input,
  FormLabel,
  InputLeftElement,
  InputGroup,
  Avatar,
  Text,
  // IconButton,
  // Box,
  Spinner,
  Menu,
  MenuButton,
  IconButton,
  MenuList,
  useColorModeValue,
  MenuItem,
  Select,
} from "@chakra-ui/react";

// import {
//   FiTrash
// } from 'react-icons/fi';

import * as ReactIcons from "react-icons/fa";
import Strings from "../config/Strings";
import MailAddressUtils from "../utils/MailAddressUtils";
import { showError } from "../common/errors";
import { QRCodeSourceChooseConfirmationButton } from "./QRCodeReaderModal";
import { mailAddressDomain, mailAddressSuffix } from "../common/constants";
import { FiDownload, FiEdit, FiEdit3, FiPlus } from "react-icons/fi";
import {VCardUtils} from "../utils/VCardUtils";
import {CsvUtils} from "../utils/CsvUtils";


const DashboardModal = ({ disclosure }) => {
  
    const [selectedOption, setSelectedOption] = useState("1");
    const [statistics, setStatistics] = useState([]);
    const [users, setUsers] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [mode, setMode] = useState(1); // 1:list, 2:users
    const [selectedDay, setSelectedDay] = useState(null); // 1:list, 2:users

  useEffect(() => {
    if (disclosure.isOpen) {
        loadSignUpStatistic();
    }
  }, [disclosure]); // eslint-disable-line react-hooks/exhaustive-deps
  
  useEffect(() => {
    console.log("ContactModal useEffect with empty");

    if (disclosure.isOpen && selectedOption === 1) {
      loadSignUpStatistic()
    }
  }, [selectedOption]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    console.log("ContactModal useEffect without param");
  }); // eslint-disable-line react-hooks/exhaustive-deps
  const loadSignUpStatistic = () => {
    setLoading(true);
    window.plexiMailService.getSignUpStatisticV2(selectedOption).then((statistic) => {
        setLoading(false);
        setStatistics(statistic);
    }).catch(e => {
        setLoading(false);
        showError(e);
    })
  }
  const showUserList = (day) => {
    setMode(2);
    setLoading(true);
    setSelectedDay(day);
    window.plexiMailService.getSignUpLogs(day).then((users) => {
        setLoading(false);
        setUsers(users);
    }).catch(e => {
        setLoading(false);
        showError(e);
    })
  };

  const shortID = (id) => {
    if (id.length > 32) {
      id = id.substring(0, 32) + "...";
    }
    return id;
  }

  const formatDate = (timestampInNanoSeconds) => {
    if (!timestampInNanoSeconds) {
      return "";
    }

    timestampInNanoSeconds = Number(timestampInNanoSeconds);
    const date = new Date(timestampInNanoSeconds / 1000000);
    return date.toLocaleString();
  }
  return (
    <Modal
      size={"xl"}
      isOpen={disclosure.isOpen}
      onClose={() => {
        disclosure.onClose();
      }}
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent maxH={{base: "", md: "80vh"}} overflow={{base: "", md:"auto"}}>
        

        <ModalHeader>
            Admin Dashboard
          <ModalCloseButton />
        </ModalHeader>

        <ModalBody>
            {mode === 1 && <>
          <VStack>

            <Select defaultValue="1" value={selectedOption} onChange={(e) => {
                setSelectedOption(e.target.value);
            }}>
                <option value="1">New users in the last seven days</option>
                <option value="2">New users in the last month</option>
            </Select>
          </VStack>
            <Table mt={4} variant="simple" w={"100%"}>
                <Thead>
                <Tr>
                    <Th>Day</Th>
                    <Th>Number of New Register User</Th>
                </Tr>
                </Thead>
                <Tbody>
                {statistics &&
                    statistics.length > 0 &&
                    statistics.map((item, index) => {
                    return (
                        <Tr
                        key={`statistic-${item.dayText}`}
                        >
                        <Td>
                            {item.dayText}
                        </Td>
                        <Td><Button variant="link" colorScheme="green" onClick={() => {
                            showUserList(item.dayText);
                        }}>{item.count}</Button></Td>
                        </Tr>
                    );
                    })}
                {isLoading && <Tr>
                    <Td colSpan={2}>
                        <Spinner />
                    </Td>
                </Tr>}
                </Tbody>
    
            </Table>
            </>}
            {mode === 2 && <>
          <VStack>
                <Text>New users of {selectedDay}</Text>
          </VStack>
            <Table mt={4} variant="simple" w={"100%"}>
                <Thead>
                <Tr>
                    <Th>ID</Th>
                    <Th>Source</Th>
                    <Th>Created At</Th>
                </Tr>
                </Thead>
                <Tbody>
                {users &&
                    users.length > 0 &&
                    users.map((item, index) => {
                    return (
                        <Tr
                        key={`user-${item.principal}`}
                        >
                        <Td>
                            {item.principal}
                        </Td>
                        <Td>
                            {item.source}
                        </Td>
                        <Td>
                            {formatDate(item.createdAt)}
                        </Td>
                        </Tr>
                    );
                    })}
                {isLoading && <Tr>
                    <Td colSpan={3}>
                        <Spinner />
                    </Td>
                </Tr>}
                </Tbody>
    
            </Table>
            </>}
        </ModalBody>

        <ModalFooter>
          {mode === 2 && <Button colorScheme='green' mr={4} onClick={() => {
            setMode(1);
          }}>Back</Button>}
          <Button colorScheme='red' mr={3} onClick={disclosure.onClose}>Close</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DashboardModal;
